<template>
    <b-button
        class=""
        :size="size"
        :variant="confirm ? 'danger' : 'outline-danger'"
        @click="remove()"
        >{{ confirm ? 'Confirm?' : 'Remove' }}</b-button
    >
</template>

<script>
    export default {
        props: ['size'],
        data() {
            return {
                confirm: false
            }
        },
        methods: {
            remove() {
                if (this.confirm) this.$emit('click')
                else this.confirm = true
            }
        }
    }
</script>

<style scoped>
</style>